// import { fetchToken } from "../../common/FetchCookie";
// import { ADMIN, BASE_URL, EMPLOYER_DATA, EMPLOYER_PROFILE_VERIFIED } from "../../common/URLs";


// const API_BASE_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_DATA}`
// const API_VERIFY_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_PROFILE_VERIFIED}`

// export const fetchEmployerData = async (page = 1) => {
//   const url = `${API_BASE_URL}?page=${page}`;
//   try {
//     const token = await fetchToken()

//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//     const data = await response.json();
//     return {
//       candidates:
//         data.response.data.map((candidate) => ({
//           ...candidate,
//           is_verified: candidate.is_verified === 1, // Convert to boolean
//         })) || [],
//       pagination: {
//         current_page: data.response.current_page,
//         last_page: data.response.last_page,
//         total: data.response.total,
//       },
//     };
//   } catch (error) {
//     console.error("API Error:", error);
//     throw error;
//   }
// };

// export const verifyEmployer = async (id, verifyData) => {
//   const url = `${API_VERIFY_URL}/${id}`;
//   try {
//     const token = await fetchToken()

//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(verifyData),
//     });
//     if (!response.ok) throw new Error(`Error updating: ${response.statusText}`);
//     const data = await response.json();
//     return {
//       ...data,
//       is_verified: true,
//     };
//   } catch (error) {
//     console.error("Verification error:", error);
//     throw error;
//   }
// };
import { fetchToken } from "../../common/FetchCookie"
import { ADMIN, BASE_URL, EMPLOYER_DATA, EMPLOYER_PROFILE_VERIFIED } from "../../common/URLs"

const API_BASE_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_DATA}`
const API_VERIFY_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_PROFILE_VERIFIED}`

export const fetchEmployerData = async (page = 1) => {
  const url = `${API_BASE_URL}?page=${page}`
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)
    const data = await response.json()
    return {
      candidates:
        data.response.data.map((candidate) => ({
          ...candidate,
          is_verified: candidate.is_verified === 1, // Convert to boolean
        })) || [],
      pagination: {
        current_page: data.response.current_page,
        last_page: data.response.last_page,
        total: data.response.total,
      },
    }
  } catch (error) {
    console.error("API Error:", error)
    throw error
  }
}

export const verifyEmployer = async (id, verifyData) => {
  const url = `${API_VERIFY_URL}/${id}`
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(verifyData),
    })
    if (!response.ok) throw new Error(`Error updating: ${response.statusText}`)
    const data = await response.json()
    return {
      ...data,
      is_verified: true,
    }
  } catch (error) {
    console.error("Verification error:", error)
    throw error
  }
}
